<template>
  <div class="yqgkcCon">
    <el-carousel height="228px">
        <el-carousel-item v-for="(item, index) in photo" :key="index" >
          <!-- <viewer :images="photo" ref="viewerRef">
            <img
              v-for="(src, index) in photo" :key="index"
              style="position: absolute;left:0px;top:0px;z-index: 3;width:100%;height:188px;opacity: 0;cursor: pointer;"
              :src="urlimg+src" 
              class="banimg"
            />
          </viewer> -->
          <img
            :src="urlimg+item"
            :key="index"
            class="banimg"
             @click="showViewer(index)"
          />
        </el-carousel-item>
    </el-carousel>
    <!-- Viewer 容器 -->
    <div v-viewer="viewerOptions" class="images">
      <img v-for="(image, index) in photo" :key="index" :src="urlimg+image" style="display: none;">
    </div>
    <p class="yqgkcCon_text">
      <vue-seamless-scroll :data="voCompanyShowsValue.farmDesc.split()"  :class-option="optionSetting">
        {{voCompanyShowsValue.farmDesc}}
      </vue-seamless-scroll> 
    </p>
    <div class="jyztqiye">
      <div class="cyList">
         <div class="lf">
            <img src="@/assets/images/onebottomzhuan.png" alt="" class="btn">
            <img src="@/assets/images/Group01.png" alt="" class="Groupimg">
         </div>
         <div class="rt">
            <span class="tit">地块总面积</span>
            <span class="num">{{numbValue.landAcre}} <span>万亩</span> </span>
         </div>
      </div>
      <div class="cyList">
         <div class="lf">
            <img src="@/assets/images/onebottomzhuan.png" alt="" class="btn">
            <img src="@/assets/images/Group02.png" alt="" class="Groupimg">
         </div>
         <div class="rt">
            <span class="tit">种植面积</span>
            <span class="num">{{numbValue.plantAcre}} <span>万亩</span> </span>
         </div>
      </div>
      <div class="cyList">
         <div class="lf">
            <img src="@/assets/images/onebottomzhuan.png" alt="" class="btn">
            <img src="@/assets/images/Group03.png" alt="" class="Groupimg">
         </div>
         <div class="rt">
            <span class="tit">种植品种</span>
            <span class="num">{{numbValue.crops}} <span>种</span> </span>
         </div>
      </div>
      <div class="cyList">
         <div class="lf">
            <img src="@/assets/images/onebottomzhuan.png" alt="" class="btn">
            <img src="@/assets/images/Group04.png" alt="" class="Groupimg">
         </div>
         <div class="rt">
            <span class="tit">物联设备</span>
            <span class="num">{{numbValue.iotDevice}}  <span>台</span> </span>
         </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  props:{
    farmId:String,
    urlimg:String,
    numbValue:Object,
  },
  name: "ykgkCov",
  data(){
    return{
      photo:[],
      voCompanyShowsValue:'',
      viewerOptions:'',
    }
  },
  computed:{
    optionSetting(){
      return{
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: 1, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        autoPlay: true, // 是否自动滚动
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
      }
    },
  },
  created(){
    this.voCompanyShowsValue = this.numbValue.farm
    this.photo = this.numbValue.farm.imgs.split(",");
    
  },
  methods:{
    showViewer(index) {
      // 获取 Viewer 实例
      const viewer = this.$el.querySelector('.images').$viewer
      // 显示指定索引的图片
      viewer.view(index)
    }
  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "@/assets/css/home.css";

.yqgkcCon{
  height: 590px;
  overflow: hidden;
  .banimg{
    width: 100%;
    height: 266px;
  }
  .yqgkcCon_text{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4; /* 定义文本的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    height: 170px;
    margin-top: 10px;
    text-indent: 2em;
  }
  .jyztqiye{
    width: 100%;
    height: 190px;
    overflow: auto;
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .cyList{
      width: 49%;
      height: 80px;
      overflow: hidden;
      .lf{
        width: 40%;
        height: 80px;
        float: left;
        position: relative;
        .btn{
          width: 100%;
          height: 100%;
        }
        .Groupimg{
          position: absolute;
          width: 37px;
          height: 37px;
          top: 10px;
          left: 26px;
          z-index: 1;
        }
      }
      .rt{
        width: 59%;
        height: 80px;
        float: right;
        text-align: left;
        color: #fff;
        font-size: 16px;
        .tit{
          display: block;
          margin-top: 10px;
        }
        .num{
          font-size: 24px;
          color: #EECF0A;
          font-family:"UnidreamLED";
          margin-top: 10px;
          display: block;
          span{
            font-size: 12px;
          }
        }
      }
    }
  }
}

</style>
